// TH UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'อพาร์ตเมนต์และโรงแรม',
  'site.currency': 'สกุลเงิน',
  'site.language': 'ภาษา',
  'site.currencySelector': 'ตัวเลือกสกุลเงิน',
  'site.languageSelector': 'ตัวเลือกภาษา',
  'site.menu': 'เมนู',
  'site.signIn': 'เข้าสู่ระบบ',
  'site.signOut': 'ออกจากระบบ',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'เปิดเมนู',
  'site.footer.copyright': 'สงวนลิขสิทธิ์',
  'site.footer.manageBooking': 'จัดการการจองของคุณ',
  'site.footer.terms': 'ข้อกำหนดและเงื่อนไข',
  'site.footer.privacy': 'นโยบายความเป็นส่วนตัว',
  'site.trust.bestPrice': 'รับประกันราคาดีที่สุด',
  'site.trust.bestPriceDesc': 'รับราคาที่ดีที่สุด',
  'site.trust.flexibleBooking': 'การจองที่ยืดหยุ่น',
  'site.trust.flexibleBookingDesc': 'เปลี่ยนแปลงและยกเลิกได้ง่าย',
  'site.trust.securePayments': 'การชำระเงินที่ปลอดภัย',
  'site.trust.securePaymentsDesc': 'ชำระเงินที่เชื่อถือและปลอดภัย',
  'site.trust.localSupport': 'การสนับสนุนในท้องถิ่น',
  'site.trust.localSupportDesc': 'เราพร้อมช่วยเหลือคุณตลอดเวลา',
  'home.heroTitle': 'ค้นหาที่พักที่สมบูรณ์แบบของคุณ',
  'home.inAustralia': 'ในประเทศออสเตรเลีย',
  'home.heroSubtitle': 'อพาร์ตเมนต์และโรงแรมสำหรับทุกประเภทของการเข้าพัก',
  'home.errorLoading': 'ไม่สามารถโหลดรายชื่อที่พักได้',
  'home.noPropertiesTitle': 'ขณะนี้ไม่มีที่พักที่พร้อมให้บริการ',
  'home.noPropertiesDescription': 'ลองค้นหาจุดหมายปลายทางเพื่อสำรวจที่พักที่พร้อมให้บริการ',
  'home.exploreStays': 'สำรวจที่พัก',
  'home.property': 'ที่พัก',
  'home.property_one': 'ที่พัก',
  'home.property_other': 'ที่พัก',
  'home.properties': 'ที่พัก',
  'home.foundInAustralia': 'พบในประเทศออสเตรเลีย',
  'search.errorLoading': 'ไม่สามารถโหลดห้องว่างได้ กรุณาลองอีกครั้ง',
  'search.noResults': 'ไม่มีที่พักที่ตรงกับเกณฑ์การค้นหา',
  'search.mapFollow': 'ค้นหาขณะที่ฉันย้ายแผนที่',
  'search.chooseLocationTitle': 'เลือกสถานที่',
  'search.chooseLocationDescription': 'เลือกจุดหมายปลายทางก่อนค้นหาที่พักที่พร้อมให้บริการ',
  'search.chooseDatesTitle': 'เลือกวันที่',
  'search.pastCheckIn': 'วันเช็คอินไม่สามารถเป็นวันในอดีตได้',
  'search.checkOutAfterCheckIn': 'วันเช็คเอาต์ต้องอยู่หลังวันเช็คอิน',
  'search.property': 'ที่พัก',
  'search.property_one': 'ที่พัก',
  'search.property_other': 'ที่พัก',
  'search.properties': 'ที่พัก',
  'search.found': 'พบ',
  'widget.where': 'ที่ไหน',
  'widget.location': 'สถานที่',
  'widget.checkInOut': 'เช็คอิน / เช็คเอาต์',
  'widget.guests': 'ผู้เข้าพัก',
  'widget.rooms': 'ห้องพัก',
  'widget.promoCode': 'รหัสโปรโมชั่น',
  'widget.promoPlaceholderCompact': 'ใส่รหัส (ถ้ามี)',
  'widget.promoPlaceholder': 'ไม่บังคับ',
  'widget.search': 'ค้นหา',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'ผู้ใหญ่',
  'widget.adults': 'ผู้ใหญ่',
  'widget.child': 'เด็ก',
  'widget.children': 'เด็ก',
  'widget.decreaseAdults': 'ลดจำนวนผู้ใหญ่',
  'widget.increaseAdults': 'เพิ่มจำนวนผู้ใหญ่',
  'widget.decreaseChildren': 'ลดจำนวนเด็ก',
  'widget.increaseChildren': 'เพิ่มจำนวนเด็ก',
  'widget.room': 'ห้อง',
  'widget.adultOption': '{count} ผู้ใหญ่',
  'widget.adultOption_one': '{count} ผู้ใหญ่',
  'widget.adultOption_other': '{count} ผู้ใหญ่',
  'widget.childOption': '{count} เด็ก',
  'widget.childOption_one': '{count} เด็ก',
  'widget.childOption_other': '{count} เด็ก',
  'widget.roomOption': '{count} ห้อง',
  'widget.roomOption_one': '{count} ห้อง',
  'widget.roomOption_other': '{count} ห้อง',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'ไม่สามารถโหลดสถานที่ได้ กรุณาลองอีกครั้ง',
  'widget.searchAria': 'ค้นหาห้องว่าง',
  'widget.dateErrorRequired': 'กรุณาเลือกทั้งวันเช็คอินและวันเช็คเอาต์',
  'widget.dateErrorPast': 'วันเช็คอินไม่สามารถเป็นวันในอดีตได้',
  'widget.dateErrorRange': 'วันเช็คเอาต์ต้องอยู่หลังวันเช็คอิน',
  'widget.dateRange.placeholder': 'เลือกวันเช็คอินและเช็คเอาต์',
  'widget.dateRange.selectCheckout': 'เลือกเช็คเอาต์',
  'widget.dateRange.aria.checkIn': 'เช็คอิน',
  'widget.dateRange.aria.checkOut': 'เช็คเอาต์',
  'widget.dateRange.aria.picker': 'ตัวเลือกช่วงวันเช็คอินและเช็คเอาต์',
  'widget.dateRange.previousMonth': 'เดือนก่อนหน้า',
  'widget.dateRange.nextMonth': 'เดือนถัดไป',
  'widget.dateRange.selectCheckIn': 'เลือกวันเช็คอิน',
  'widget.dateRange.selectCheckOut': 'เลือกวันเช็คเอาต์',
  'widget.dateRange.resetToday': 'รีเซ็ตเป็นวันนี้',
  'widget.dateRange.done': 'เสร็จสิ้น',
  'property.heroAlt': 'ภาพหลักของที่พัก',
  'property.fallbackName': 'ที่พักที่เลือกโดย {site}',
  'property.chooseRoom': 'เลือกห้องพักของคุณ',
  'property.filterBy': 'กรองตาม:',
  'property.filterAll': 'ทุกห้อง',
  'property.filterStudios': 'สตูดิโอ',
  'property.filter1Bed': '1 ห้องนอน',
  'property.filter2Bed': '2 ห้องนอน',
  'property.filterApartments': 'อพาร์ตเมนต์',
  'property.sortBy': 'เรียงลำดับตาม:',
  'property.sortRecommended': 'แนะนำ',
  'property.sortPriceLow': 'ราคา: ต่ำไปสูง',
  'property.sortPriceHigh': 'ราคา: สูงไปต่ำ',
  'property.errorLoading': 'ไม่สามารถโหลดห้องว่างได้ กรุณาลองอีกครั้ง',
  'property.noRooms': 'ไม่มีห้องว่าง',
  'property.noRoomsDescription': 'ลองวันที่หรือจำนวนผู้เข้าพักอื่น',
  'property.totalForNights': 'รวม {nights} คืน',
  'property.perNight': 'ต่อคืน',
  'property.night': 'คืน',
  'property.night_one': 'คืน',
  'property.night_other': 'คืน',
  'property.nights': 'คืน',
  'property.freeCancellation': 'ยกเลิกฟรี',
  'property.selectRoom': 'เลือกห้อง',
  'property.selected': 'เลือกแล้ว',
  'property.continue': 'ดำเนินการต่อ',
  'property.previousPhoto': 'รูปก่อนหน้า',
  'property.nextPhoto': 'รูปถัดไป',
  'property.addToWishlist': 'เพิ่มในรายการโปรด',
  'property.popularChoice': 'ตัวเลือกยอดนิยม',
  'property.showMore': 'แสดงเพิ่มเติม',
  'property.showLess': 'แสดงน้อยลง',
  'property.maxOccupancy': 'จำนวนผู้เข้าพักสูงสุด:',
  'property.size': 'ขนาด:',
  'property.bedType': 'ประเภทเตียง:',
  'property.roomAmenities': 'สิ่งอำนวยความสะดวกในห้อง',
  'property.showMoreAmenities': 'อีก {count} รายการ',
  'property.guests': 'ผู้เข้าพัก',
  'property.adults': 'ผู้ใหญ่',
  'property.children': 'เด็ก',
  'property.onlyRoomsLeft': 'เหลือเพียง {count} ห้อง',
  'property.onlyRoomsLeft_one': 'เหลือเพียง {count} ห้อง',
  'property.onlyRoomsLeft_other': 'เหลือเพียง {count} ห้อง',
  'property.lastBookedMinutes': 'การจองล่าสุดเมื่อ {count} นาทีที่แล้ว',
  'property.lastBookedMinutes_one': 'การจองล่าสุดเมื่อ {count} นาทีที่แล้ว',
  'property.lastBookedMinutes_other': 'การจองล่าสุดเมื่อ {count} นาทีที่แล้ว',
  'property.lastBookedHours': 'การจองล่าสุดเมื่อ {count} ชั่วโมงที่แล้ว',
  'property.lastBookedHours_one': 'การจองล่าสุดเมื่อ {count} ชั่วโมงที่แล้ว',
  'property.lastBookedHours_other': 'การจองล่าสุดเมื่อ {count} ชั่วโมงที่แล้ว',
  'property.lastBookedDays': 'การจองล่าสุดเมื่อ {count} วันที่แล้ว',
  'property.lastBookedDays_one': 'การจองล่าสุดเมื่อ {count} วันที่แล้ว',
  'property.lastBookedDays_other': 'การจองล่าสุดเมื่อ {count} วันที่แล้ว',
  'property.checkInTime': 'เช็คอิน {time}',
  'property.checkOutTime': 'เช็คเอาต์ {time}',
  'property.compare': 'เปรียบเทียบ',
  'property.taxesIncluded': 'ต่อคืน รวมภาษีและค่าธรรมเนียม',
  'property.chooseRate': 'เลือกอัตราของคุณ',
  'property.yourSelection': 'ที่คุณเลือก',
  'property.aboutRoom': 'เกี่ยวกับห้องนี้',
  'property.roomDetails': 'รายละเอียดห้อง',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'กลับไปที่รายการห้อง',
  'property.standardRate': 'อัตรามาตรฐาน',
  'property.noPromotion': 'ไม่มีโปรโมชั่นสำหรับอัตรานี้',
  'property.youSave': 'คุณประหยัด (ลด {percent}%) - {amount}',
  'property.inclusions': 'สิ่งที่รวม:',
  'property.viewAllPhotos': 'ดูรูปทั้งหมด',
  'property.seeOnMap': 'ดูบนแผนที่',
  'room.perNight': 'คืน',
  'room.sleeps': 'รองรับ',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'ว่าง',
  'room.select': 'เลือก',
  'room.selected': 'เลือกแล้ว',
  'card.viewAvailability': 'ดูห้องว่าง',
  'card.from': 'จาก',
  'card.night': 'คืน',
  'card.checkAvailability': 'เช็คห้องว่าง',
  'card.saveToFavourites': 'บันทึกเป็นรายการโปรด',
  'card.ratingExcellent': 'ยอดเยี่ยม',
  'card.ratingVeryGood': 'ดีมาก',
  'card.ratingGood': 'ดี',
  'card.ratingGuest': 'คะแนนจากผู้เข้าพัก',
  'guest.stepChooseRoom': 'เลือกห้อง',
  'guest.stepGuestDetails': 'รายละเอียดผู้เข้าพัก',
  'guest.stepPayment': 'การชำระเงิน',
  'guest.stepConfirmation': 'ยืนยัน',
  'guest.title': 'กรอกข้อมูลผู้เข้าพัก',
  'guest.subtitle': 'กรุณากรอกข้อมูลของคุณ',
  'guest.firstName': 'ชื่อ',
  'guest.lastName': 'นามสกุล',
  'guest.email': 'อีเมล',
  'guest.emailHint': 'ยืนยันการจองจะส่งไปยังอีเมลนี้',
  'guest.country': 'ประเทศ',
  'guest.selectCountry': 'เลือกประเทศ',
  'guest.searchCountry': 'ค้นหาประเทศ…',
  'guest.loadingCountries': 'กำลังโหลดประเทศ…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'รหัสไปรษณีย์',
  'guest.phone': 'หมายเลขโทรศัพท์',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'กรอกหมายเลขโทรศัพท์',
  'guest.address': 'ที่อยู่',
  'guest.city': 'เมือง',
  'guest.specialRequests': 'คำขอพิเศษ (ไม่บังคับ)',
  'guest.specialRequestsPlaceholder': 'มีคำขอพิเศษหรือไม่?',
  'guest.termsPrefix': 'เมื่อทำการจองนี้ ฉันยอมรับ',
  'guest.terms': 'ข้อกำหนดและเงื่อนไข',
  'guest.termsAnd': 'และ',
  'guest.privacy': 'นโยบายความเป็นส่วนตัว',
  'guest.termsSuffix': ' และยอมรับเงื่อนไขการจอง',
  'guest.marketingOptOut': 'ฉันไม่ต้องการรับข้อความทางการตลาด',
  'guest.cardVerify': 'จะมีการตรวจสอบบัตรชั่วคราว 1 {currency} คุณจะไม่ถูกเรียกเก็บเงินตอนนี้',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'การชำระเงินจะเก็บที่ที่พัก',
  'guest.noRoomsSelected': 'ยังไม่ได้เลือกห้อง',
  'guest.noPropertySelected': 'ยังไม่ได้เลือกที่พัก',
  'guest.paymentStillLoading': 'ตัวเลือกการชำระเงินกำลังโหลด กรุณาลองใหม่ในอีกสักครู่',
  'guest.submitProcessing': 'กำลังดำเนินการ…',
  'guest.submitVerifyCard': 'ยืนยันบัตรและยืนยันการจอง',
  'guest.submitConfirm': 'ยืนยันการจอง',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'การชำระเงิน',
  'payment.method': 'วิธีการชำระเงิน',
  'payment.cardDetailsHint':
    'กรอกรายละเอียดบัตรของคุณอย่างปลอดภัยด้านล่าง รายละเอียดบัตรของคุณจะถูกทำเป็นโทเค็นและไม่สัมผัสเซิร์ฟเวอร์ของเรา',
  'payment.loadingForm': 'กำลังโหลดแบบฟอร์มการชำระเงิน…',
  'payment.formUnavailable': 'แบบฟอร์มการชำระเงินไม่พร้อมใช้งาน',
  'payment.acceptTerms': 'ฉันยอมรับข้อกำหนดและเงื่อนไขและนโยบายการยกเลิก',
  'payment.payNow': 'ชำระเงินตอนนี้',
  'payment.processing': 'กำลังดำเนินการ…',
  'payment.noRoomsSelected': 'ยังไม่ได้เลือกห้อง',
  'payment.redirecting': 'กำลังเปลี่ยนเส้นทางไปยังหน้าการชำระเงินที่ปลอดภัย…',
  'payment.notConfigured': 'Quickstream ไม่ได้กำหนดค่าสำหรับที่พักนี้',
  'payment.noScript': 'ไม่สามารถโหลดบริการการชำระเงิน Quickstream ได้ กรุณารีเฟรชหน้า',
  'payment.formNotLoaded': 'แบบฟอร์มการชำระเงินยังไม่โหลด กรุณารีเฟรชหน้า',
  'payment.cardDetails': 'การชำระเงินล้มเหลว กรุณาตรวจสอบรายละเอียดบัตร',
  'payment.tokenizationFailed': 'การสร้างโทเค็นบัตรล้มเหลว กรุณาลองอีกครั้ง',
  'payment.failed': 'การชำระเงินล้มเหลว',
  'payment.statusResult': 'สถานะการชำระเงิน: {status} กรุณาลองอีกครั้ง',
  'confirmation.loading': 'กำลังโหลดการจองของคุณ…',
  'confirmation.notFound': 'ไม่พบการจอง กรุณาตรวจสอบหมายเลขอ้างอิงการจองและลองใหม่',
  'confirmation.errorGeneric': 'ไม่สามารถยืนยันการจองของคุณได้ กรุณาติดต่อฝ่ายสนับสนุน',
  'confirmation.errorLoadDetails': 'ไม่สามารถโหลดรายละเอียดการจองได้',
  'confirmation.couldNotComplete': 'เราไม่สามารถดำเนินการชำระเงินของคุณให้เสร็จสมบูรณ์ได้',
  'confirmation.startNew': 'เริ่มการจองใหม่',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': 'ไม่พบเซสชันการชำระเงิน กรุณาติดต่อฝ่ายสนับสนุน',
  'confirmation.paymentStateInvalid': 'การชำระเงินไม่อยู่ในสถานะที่สมบูรณ์ กรุณาเริ่มใหม่',
  'confirmation.paymentFailedDeclined':
    'การชำระเงินของคุณไม่สามารถเสร็จสมบูรณ์ได้ กรุณาตรวจสอบรายละเอียดบัตรและลองใหม่ หรือใช้วิธีการชำระเงินอื่น',
  'confirmation.paymentTimeout': 'การชำระเงินใช้เวลานานเกินไป กรุณาลองอีกครั้ง',
  'confirmation.paymentGatewayUnavailable':
    'ระบบการชำระเงินขัดข้องชั่วคราว กรุณาลองใหม่ในอีกสักครู่',
  'confirmation.paymentUnknown': 'ไม่สามารถยืนยันการชำระเงินได้: {message}',
  'confirmation.paymentGenericError':
    'ไม่สามารถยืนยันการชำระเงินได้ กรุณาลองอีกครั้งหรือติดต่อฝ่ายสนับสนุน',
  'summary.title': 'สรุปการจองของคุณ',
  'summary.yourBooking': 'สรุปการจองของคุณ',
  'summary.noRoomsSelected': 'ยังไม่ได้เลือกห้อง',
  'summary.checkIn': 'เช็คอิน',
  'summary.checkOut': 'เช็คเอาต์',
  'summary.lengthOfStay': 'ระยะเวลาการเข้าพัก',
  'summary.guests': 'ผู้เข้าพัก',
  'summary.nights': '{nights} คืน',
  'summary.nights_one': '{nights} คืน',
  'summary.nights_other': '{nights} คืน',
  'summary.totalForNights': 'รวม {nights} คืน',
  'summary.includingTaxes': 'รวมภาษีและค่าธรรมเนียม',
  'summary.discount': 'ประหยัด {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'การจองได้รับการยืนยัน!',
  'detail.received': 'ได้รับการจองแล้ว',
  'detail.referenceIntro': 'หมายเลขอ้างอิงการจองของคุณคือ',
  'detail.reservationId': 'หมายเลขการจอง:',
  'detail.processing':
    'การจองของคุณกำลังอยู่ในระบบ คุณจะได้รับอีเมลยืนยันเมื่อการชำระเงินได้รับการยืนยัน',
  'detail.guest': 'ผู้เข้าพัก',
  'detail.rooms': 'ห้องพัก',
  'detail.night': 'คืน',
  'detail.nights': 'คืน',
  'detail.adult': 'ผู้ใหญ่',
  'detail.adults': 'ผู้ใหญ่',
  'detail.child': 'เด็ก',
  'detail.infant': 'ทารก',
  'detail.priceBreakdown': 'รายละเอียดราคา',
  'detail.subtotal': 'ราคาย่อย',
  'detail.taxes': 'ภาษี',
  'detail.fees': 'ค่าธรรมเนียม',
  'detail.discounts': 'ส่วนลด',
  'detail.surcharge': 'ค่าธรรมเนียมบัตร',
  'detail.grandTotal': 'ยอดรวมทั้งสิ้น',
  'priceBreakdown.roomSubtotal': 'ราคาย่อยห้องพัก',
  'priceBreakdown.total': 'รวม',
  'detail.deposit': 'เงินมัดจำ',
  'detail.depositDueBy': 'ครบกำหนดภายใน',
  'detail.arrival': 'ถึง',
  'detail.specialRequests': 'คำขอพิเศษ',
  'detail.backToHome': 'กลับสู่หน้าหลัก',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'ลองใหม่',
  'shared.close': 'ปิด',
  'shared.back': 'กลับ',
  'shared.previous': 'ก่อนหน้า',
  'shared.next': 'ถัดไป',
  'validation.firstNameRequired': 'กรุณากรอกชื่อ',
  'validation.lastNameRequired': 'กรุณากรอกนามสกุล',
  'validation.emailRequired': 'กรุณากรอกอีเมลที่ถูกต้อง',
  'validation.phoneRequired': 'กรุณากรอกหมายเลขโทรศัพท์',
  'validation.addressRequired': 'กรุณากรอกที่อยู่',
  'validation.cityRequired': 'กรุณากรอกเมือง',
  'validation.countryRequired': 'กรุณาเลือกประเทศ',
  'validation.postalCodeRequired': 'กรุณากรอกรหัสไปรษณีย์',
  'error.pmsUnavailable':
    'ขออภัย ห้องนี้ไม่ว่างสำหรับวันที่คุณเลือกแล้ว กรุณากลับไปเลือกวันที่อื่นหรือห้องอื่น',
  'error.pmsSyncError': 'เราไม่สามารถเชื่อมต่อกับระบบของที่พักได้ กรุณาลองใหม่ในอีกสักครู่',
  'error.paymentNotConfigured':
    'การชำระเงินยังไม่ได้กำหนดค่าสำหรับที่พักนี้ กรุณาเลือกที่พักอื่นหรือติดต่อฝ่ายสนับสนุน',
  'error.paymentStartFailed': 'เกิดข้อผิดพลาดขณะเริ่มการชำระเงิน กรุณาลองอีกครั้ง',
  'error.bookingFailed': 'การจองล้มเหลว กรุณาลองอีกครั้ง',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'จองที่พัก',
  'site.title.suffix': 'อพาร์ตเมนต์และโรงแรม',
  'site.title.home': 'หน้าหลัก',
  'site.title.search': 'ค้นหา',
  'site.title.property': 'ที่พัก',
  'site.title.room': 'ห้องพัก',
  'site.title.guestDetails': 'รายละเอียดผู้เข้าพัก',
  'site.title.payment': 'การชำระเงิน',
  'site.title.confirmation': 'การจองได้รับการยืนยัน',
  'site.title.bookingLookup': 'ค้นหาการจองของคุณ',
  'site.title.bookingDetails': 'รายละเอียดการจอง',
  'site.title.cancellation': 'ยกเลิกการจอง',
  'site.title.reservationDetail': 'รายละเอียดการจอง',
  'site.title.signIn': 'เข้าสู่ระบบ',
  'site.title.signUp': 'ลงทะเบียน',
  'site.title.notFound': 'ไม่พบหน้า',
  'notFound.title': 'ไม่พบหน้า',
  'notFound.message': 'ไม่มีหน้าที่คุณกำลังค้นหา',
  'notFound.backHome': 'กลับสู่หน้าหลัก',
  'home.heroAlt': 'ทิวทัศน์เมืองออสเตรเลีย',
  'home.featuredProperties': 'ที่พักแนะนำ',
  'home.popularDestinations': 'จุดหมายปลายทางยอดนิยม',
  'common.reviews': '{count} รีวิว',
  'common.reviews_one': '{count} รีวิว',
  'common.reviews_other': '{count} รีวิว',
  'common.loading': 'กำลังโหลด',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'จาก',
  'common.select': 'เลือก…',
  'common.search': 'ค้นหา…',
  'common.selectLocation': 'เลือกสถานที่',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'ไม่มีตัวเลือก',
  'common.code': 'รหัส',
  'common.searchCode': 'ค้นหารหัส…',
  'filter.title': 'ตัวกรอง',
  'filter.price': 'ราคา',
  'filter.priceMinimum': 'ต่ำสุด',
  'filter.priceMaximum': 'สูงสุด',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'ประเภทที่พัก',
  'filter.propertyType.hotel': 'โรงแรม',
  'filter.propertyType.apartment': 'อพาร์ตเมนต์',
  'filter.propertyType.resort': 'รีสอร์ต',
  'filter.amenities': 'สิ่งอำนวยความสะดวก',
  'filter.amenity.pool': 'สระว่ายน้ำ',
  'filter.amenity.parking': 'ที่จอดรถ',
  'filter.amenity.breakfast': 'รวมอาหารเช้า',
  'filter.rating': 'คะแนน',
  'filter.rating.any': 'คะแนนใดก็ได้',
  'filter.rating.5': '5 ดาว',
  'filter.rating.4': '4 ดาวขึ้นไป',
  'filter.rating.3': '3 ดาวขึ้นไป',
  'filter.more': 'เพิ่มเติม',
  'filter.more.freeCancellation': 'ยกเลิกฟรี',
  'filter.more.payAtProperty': 'ชำระที่ที่พัก',
  'filter.clear': 'ล้าง',
  'filter.apply': 'ใช้ตัวกรอง',
  'card.reviews_one': 'รีวิว',
  'card.reviews_other': 'รีวิว',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'อายุ 0 - 12 ปี',
  'auth.orContinueWith': 'หรือดำเนินการต่อด้วย',
  'auth.signIn.title': 'เข้าสู่บัญชีของคุณ',
  'auth.signIn.subtitle':
    'ยินดีต้อนรับกลับ! เข้าสู่ระบบเพื่อจัดการการจอง ดูที่พัก และเข้าถึงข้อเสนอพิเศษ',
  'auth.email': 'อีเมล',
  'auth.emailPlaceholder': 'กรอกที่อยู่อีเมล',
  'auth.emailRequired': 'กรุณากรอกอีเมล',
  'auth.emailInvalid': 'กรุณากรอกอีเมลที่ถูกต้อง',
  'auth.password': 'รหัสผ่าน',
  'auth.passwordPlaceholder': 'กรอกรหัสผ่าน',
  'auth.createPasswordPlaceholder': 'สร้างรหัสผ่าน',
  'auth.passwordRequired': 'กรุณากรอกรหัสผ่าน',
  'auth.passwordMinLength': 'รหัสผ่านต้องมีอย่างน้อย {min} ตัวอักษร',
  'auth.passwordPattern': 'รหัสผ่านต้องประกอบด้วยตัวอักษรและตัวเลข',
  'auth.passwordHint': 'ใช้อย่างน้อย {min} ตัวอักษร โดยผสมตัวอักษร ตัวเลข และสัญลักษณ์',
  'auth.showPassword': 'แสดงรหัสผ่าน',
  'auth.hidePassword': 'ซ่อนรหัสผ่าน',
  'auth.keepSignedIn': 'ให้ฉันเข้าสู่ระบบตลอดไป',
  'auth.forgotPassword': 'ลืมรหัสผ่าน?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'เข้าสู่ระบบ',
  'auth.signingIn': 'กำลังเข้าสู่ระบบ...',
  'auth.signInError': 'เข้าสู่ระบบล้มเหลว กรุณาลองอีกครั้ง',
  'auth.googleError': 'การเข้าสู่ระบบด้วย Google ล้มเหลว',
  'auth.noAccount': 'ยังไม่มีบัญชี?',
  'auth.createAccount': 'สร้างบัญชี',
  'auth.signUp.title': 'สร้างบัญชีของคุณ',
  'auth.signUp.subtitle': 'เข้าร่วม {site} เพื่อจัดการการจอง บันทึกที่พักโปรด และรับข้อเสนอพิเศษ',
  'auth.firstName': 'ชื่อ',
  'auth.firstNamePlaceholder': 'กรอกชื่อ',
  'auth.firstNameRequired': 'กรุณากรอกชื่อ',
  'auth.lastName': 'นามสกุล',
  'auth.lastNamePlaceholder': 'กรอกนามสกุล',
  'auth.lastNameRequired': 'กรุณากรอกนามสกุล',
  'auth.mobile': 'หมายเลขโทรศัพท์มือถือ',
  'auth.mobilePlaceholder': 'กรอกหมายเลขโทรศัพท์มือถือ',
  'auth.dialingCode': 'รหัสโทรศัพท์ประเทศ',
  'auth.mobileRequired': 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
  'auth.mobileInvalid': 'กรุณากรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
  'auth.confirmPassword': 'ยืนยันรหัสผ่าน',
  'auth.confirmPasswordPlaceholder': 'ยืนยันรหัสผ่านของคุณ',
  'auth.termsAgree': 'ฉันยอมรับ',
  'auth.termsRequired': 'คุณต้องยอมรับข้อกำหนดและเงื่อนไขและนโยบายความเป็นส่วนตัว',
  'auth.marketingConsent': 'ฉันต้องการรับข้อเสนอพิเศษและแรงบันดาลใจในการเดินทางจาก {site}',
  'auth.signUpError': 'ไม่สามารถสร้างบัญชีได้ กรุณาลองอีกครั้ง',
  'auth.signUp': 'ลงทะเบียน',
  'auth.creatingAccount': 'กำลังสร้างบัญชี...',
  'auth.createAccountButton': 'สร้างบัญชี',
  'auth.alreadyHaveAccount': 'มีบัญชีแล้ว?',
  'auth.passwordMismatch': 'รหัสผ่านไม่ตรงกัน',
  'pricing.title': 'สรุปราคา',
  'pricing.noRoomsSelected': 'ยังไม่ได้เลือกห้อง กรุณากลับไปเลือกห้อง',
  'pricing.backToAvailability': 'กลับไปที่ห้องว่าง',
  'pricing.continue': 'ดำเนินการต่อไปยังรายละเอียดผู้เข้าพัก',
  'property.youSavePercent': 'คุณประหยัด (ลด {percent}%)',
  'property.includingTaxesFees': '(รวมภาษีและค่าธรรมเนียม)',
  'map.zoomIn': 'ขยายเข้า',
  'map.zoomOut': 'ขยายออก',
  'map.viewFullMap': 'ดูในแผนที่เต็มหน้า',
  'booking.progress': 'ความคืบหน้าการจอง',
  'reservationDetail.resetAria': 'รีเซ็ตสถานะการจอง',
  'bookingLookup.title': 'ค้นหาการจองของคุณ',
  'bookingLookup.description':
    'กรอกหมายเลขอ้างอิงการจองและอีเมลเพื่อดู แก้ไข หรือยกเลิกการจองของคุณ',
  'bookingLookup.bookingReference': 'หมายเลขอ้างอิงการจอง',
  'bookingLookup.placeholder': 'เช่น SYD-260815-0001',
  'bookingLookup.lookingUp': 'กำลังค้นหา…',
  'bookingLookup.findBooking': 'ค้นหาการจอง',
  'bookingLookup.notFound': 'ไม่พบการจอง ลอง BK-2026-001, alex.morgan@example.com และ Morgan',
  'cancellation.title': 'ยกเลิกการจอง',
  'cancellation.property': 'ที่พัก',
  'cancellation.details': 'รายละเอียดการยกเลิก',
  'cancellation.penalty': 'ค่าปรับการยกเลิก',
  'cancellation.refund': 'จำนวนเงินคืน',
  'cancellation.totalPaid': 'ยอดที่ชำระ:',
  'cancellation.reasonLabel': 'เหตุผลในการยกเลิก (ไม่บังคับ)',
  'cancellation.understand': 'ฉันเข้าใจว่าการกระทำนี้ไม่สามารถย้อนกลับได้',
  'cancellation.cancelledDemo':
    'การจองของคุณถูกยกเลิกในเดโม UI นี้แล้ว จำนวนเงินคืน: {{refundAmount}}',
  'cancellation.confirm': 'ยืนยันการยกเลิก',
  'cancellation.notFound': 'ไม่พบการจอง',
  'bookingDetails.title': 'รายละเอียดการจอง',
  'bookingDetails.notFound': 'ไม่พบการจอง',
  'bookingDetails.checkIn': 'เช็คอิน:',
  'bookingDetails.checkOut': 'เช็คเอาต์:',
  'bookingDetails.rooms': 'ห้องพัก',
  'bookingDetails.guest': 'ผู้เข้าพัก',
  'bookingDetails.freeCancellationUntil': 'ยกเลิกฟรีจนถึง {date}',
  'bookingDetails.total': 'รวม:',
  'reservationDetail.loading': 'กำลังโหลดการจองของคุณ…',
  'reservationDetail.noReference': 'ไม่ได้ระบุหมายเลขอ้างอิงการจอง',
  'reservationDetail.loadError': 'ไม่สามารถโหลดรายละเอียดการจองได้',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'กำลังโหลดสถานที่…',
  'common.couldNotLoadLocations': 'ไม่สามารถโหลดสถานที่ได้',
  'common.searchLocationPlaceholder': 'ค้นหาประเทศ เมือง หรือที่พัก',
  'common.collapse': 'ยุบ',
  'common.expand': 'ขยาย',
  'map.loadingGoogle': 'กำลังโหลด Google Map…',
  'map.errorGoogle': 'ไม่สามารถโหลด Google Maps ได้',
  'map.errorMap': 'ไม่สามารถโหลดแผนที่ได้',
  'map.greatLocation': 'ทำเลดีเยี่ยม',
  'home.trust.secureBooking': 'การจองที่ปลอดภัย',
  'home.trust.secureBookingDesc': 'ข้อมูลของคุณปลอดภัยกับเรา',
  'home.trust.bestPrice': 'รับประกันราคาดีที่สุด',
  'home.trust.bestPriceDesc': 'พบราคาที่ต่ำกว่า? เราจะปรับราคาให้เท่ากัน',
  'home.trust.localSupport': 'สนับสนุนตลอด 24 ชั่วโมง',
  'home.trust.localSupportDesc': 'เราพร้อมช่วยเหลือคุณตลอดเวลา',
  'home.trust.flexibleBooking': 'ตัวเลือกที่ยืดหยุ่น',
  'home.trust.flexibleBookingDesc': 'ยกเลิกฟรีสำหรับอัตราที่เลือก',
  'promotion.memberPromo': 'โปรโมชั่นสมาชิก',
  'promotion.save': 'ประหยัด',
  'property.memberRate': 'อัตราสมาชิก',
  'property.hideAmenities': 'ซ่อนสิ่งอำนวยความสะดวก',
  'property.showAllAmenities': 'แสดงสิ่งอำนวยความสะดวกทั้งหมด',
  'property.chooseRatePromo': 'เลือกอัตราที่คุณต้องการ - อัตราสมาชิกมอบส่วนลดพิเศษ!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': 'ลด {percent}%',
  'gallery.imageAlt': '{title} รูปที่ {current} จาก {total}',
  'gallery.thumbnailAlt': 'ไปยังรูปที่ {current} จาก {total}',
  'gallery.previewAlt': 'ตัวอย่าง {title}',
  'detail.night_one': 'คืน',
  'detail.night_other': 'คืน',
  'detail.adult_one': 'ผู้ใหญ่',
  'detail.adult_other': 'ผู้ใหญ่',
  'detail.child_one': 'เด็ก',
  'detail.child_other': 'เด็ก',
  'detail.infant_one': 'ทารก',
  'detail.infant_other': 'ทารก',
} as const;
